import React, { useState } from "react";
import { useBenefitGateCore } from "../../core/useBenefitsCore";
import { EShowMode, EBenefitTypes } from "../../enums/benefits.enums";
import { BenefitsModal } from "../../../../components/common/BenefitsModal/BenefitsModal";

export type PreviewGateProps = {
    benefit: EBenefitTypes;
    featureName: string;
    onPreview: () => void;
    children: React.ReactElement;
};

export function BenefitPreviewGate(props: PreviewGateProps) {
    const { benefit, featureName, onPreview, children } = props;

    // Check if user has the benefit
    const core = useBenefitGateCore(benefit, { showWhenBlocked: EShowMode.DISABLED });
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (core.decision.mode === EShowMode.NULL) return null;

    // If they have the benefit, just render the children normally
    if (!core.disabled) return children;

    // If they DON'T have the benefit, we intercept the click
    const child = React.Children.only(children);

    const clonedChild = React.cloneElement(child, {
        onClick: (e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            setIsModalOpen(true);
        }
    });

    return (
        <>
            {clonedChild}
            <BenefitsModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onPreview={() => {
                    setIsModalOpen(false);
                    onPreview();
                }}
                featureName={featureName}
            />
        </>
    );
}
